export class ForeignIdSelector {
  private static readonly Priorities = ['MLB', 'NPB', 'KBO', 'TMBB', 'PBR', 'AMA', 'PG', 'CCBL', 'NCAA', 'D1B'];

  public static get(foreignIds: string[]): string {
    if (!foreignIds || foreignIds.length === 0) return '';
    if (foreignIds.length === 1) return foreignIds[0];

    for (const prefix of this.Priorities) {
      const foreignId = foreignIds.find((f) => f && f.startsWith(prefix));
      if (foreignId) {
        return foreignId.replace(`${prefix}-`, '');
      }
    }

    return foreignIds[0];
  }
}
